var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueueScreenStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 30.9461C11.9726 30.9461 11.4979 30.5148 11.4451 29.9757C10.4958 20.1635 9.75738 17.0365 0.949369 16.1739C0.421942 16.12 0 15.6348 0 15.0957C0 14.5565 0.421942 14.0713 0.949369 14.0174C9.96836 13.1548 10.4958 10.7826 11.4451 0.970437C11.4451 0.431306 11.9726 0 12.5 0C13.0274 0 13.5021 0.431306 13.5549 0.970437C14.5042 10.7826 15.0844 13.1548 24.0506 14.0174C24.5781 14.0713 25 14.5565 25 15.0957C25 15.6348 24.5781 16.12 24.0506 16.1739C15.1899 17.0365 14.5042 20.1635 13.5549 30.0296C13.5549 30.5687 13.0802 31 12.5 31V30.9461Z",
    fill: "#0066FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueueScreenStarIcon);
export default __webpack_public_path__ + "static/media/queueScreenStarIcon.74e398762c489985227853a9199128b6.svg";
export { ForwardRef as ReactComponent };